<template>
    <CodiceFeanorView tool-module="entropy" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
